import { getStalePayments } from '@/API/repositories/order';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useEffect, useState } from 'react';

const useFollowUpPayments = () => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();

	const [displayedRows, setDisplayedRows] = useState();

	const isLoading = hasUnfilledRequest(getStalePayments);

	const fetchStalePayments = async (payload = {}) => {
		const response = await makeRequest(getStalePayments.bind(null, payload));

		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}

		setDisplayedRows(response.data);
	};

	useEffect(() => {
		fetchStalePayments();
	}, []);

	return {
		displayedRows,
		fetchStalePayments,
		isLoading,
	};
};

export default useFollowUpPayments;
